module.exports = __webpack_public_path__ + "static/assets/f889cdd86f37f932db0f7a72dff7039c.png";